import type { AgentSessionSource } from "./types";

/** The user-role row a new project's coordinator greets from; the user never typed it. */
export function isProjectKickoffMessage(message: {
  role: string;
  originSource?: AgentSessionSource;
}): boolean {
  return message.role === "user" && message.originSource === "project_kickoff";
}
